import * as yup from 'yup';
import { MediaCell } from '@web/atoms';
import { requiredImageFromCMSSchema } from '../schemas';
import { schema as muxVideoSchema } from './mux_video';

export const component = MediaCell;

const transformMediaAsset = value => {
  const asset = value?.[0]?.asset || value?.[0] || value;

  if (!asset || asset.src || asset.playbackId) {
    return asset;
  }

  switch (asset.component) {
    case 'mux_video':
      return muxVideoSchema.validateSync(asset);
    default:
      return requiredImageFromCMSSchema.validateSync(asset);
  }
};

const requiredMediaAssetSchema = yup
  .mixed()
  .transform(transformMediaAsset)
  .required();

export const schema = yup
  .object({
    mobileAsset: requiredMediaAssetSchema,
    desktopAsset: requiredMediaAssetSchema,
    roundedAsset: yup.boolean(),
  })
  .camelCase()
  .transform(value => ({
    mobileAsset: value.mobileAsset,
    desktopAsset: value.desktopAsset,
    roundedAsset: value.roundedAsset || false,
  }));
